module.exports = __webpack_public_path__ + "img/nav_pic03.c5408b80.png";